<main class="main">
    <div class="main-wrapper">
        <section class="padding-first about1" id="about_us">
        <div class="container">

	        <a [routerLink]="['/news']" [routerLinkActive]="['active']" class="more">
	            <div class="icon-back">
	                <span>Back</span>
	            </div>
	        </a>


	        <div>
	          	<div class="bl-rows">
		            <div class="text">
                        <h2>We are delighted to announce the appointment of Carolina as our new Managing Director for the Middle East, Africa, and Asia Pacific regions.</h2>

		                <span>By Gennius June  25, 2024</span>
		            </div>
		            <div class="img">
		                <img src="./assets/img/gennius/bg-inside-notice10.webp">
		            </div>
	          	</div>
	        </div>

	          	<div class="bl-center">

                    <p>Carolina, welcome to the Gennius XYZ family! Your leadership and vision are invaluable as we continue to innovate and expand our reach globally. Together with @Seed Group and @The Private Office of Sheikh Saeed bin Ahmed Al Maktoum, we are poised to take our Human-to-Human loyalty technology to unprecedented heights. 🌍🚀
                    </p>

		            <p>Carolina is a multilingual professional with strong interpersonal skills and a formidable negotiator. She excels in identifying new business opportunities, facilitating strategic visions, and driving revenue growth. Known for her leadership and team-building abilities, Carolina has a proven track record in developing successful relationships with C-Suite executives and stakeholders. She has extensive experience in financial institutions, B2B, B2B2C, B2C, start-ups, and governmental institutions. Her global experience includes living in the UK, Spain, Saudi Arabia, China, and the UAE.
                    </p>

                    <p>In addition, we are proud to unveil our latest digital platform, Imagine as One, launched during the grand opening of our Dubai base, the Gennius Global Hub. Imagine as One reimagines loyalty programs, offering users a centralized, secure location to manage their digital assets seamlessly. ➡️ One currency, one wallet, and one unified global marketplace—Imagine as One simplifies transactions across boundaries, enhancing the consumer experience. 💳📱
                    </p>

					<p>With over 17 million active users worldwide, we are committed to leveraging our innovative technology to meet the unique needs of every market. Dubai, hailed as the capital of digital strategy, provides the perfect backdrop for our expansion and continued innovation. 📈🏙️
                    </p>


                    <p>🌍 Together, we are paving the way for a new era in loyalty systems, making digital assets more accessible and adaptable for users globally.
                    </p>

                    <p>Join us in welcoming @Carolina and celebrating the launch of Imagine as One! 📱✨<br>
                        #GenniusXYZ #ImagineAsOne #FintechInnovation #GlobalExpansion #LoyaltyTechnology #DubaiLaunch #SeedGroup
                    </p>



                    <p>For more information about <strong>Gennius XYZ</strong>, please visit <a href="https://gennius.xyz/"><strong>www.gennius.xyz</strong></a>.</p>


	          	</div>

        </div>
      </section>


    </div>
</main>
<app-footer></app-footer>